import React, { createContext, useContext, useState, useCallback } from "react";
import { translations, localizeTerm, localize } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("pa_lang") === 'it' ? 'it' : 'en'; }
    catch { return 'en'; }
  });


  const changeLang = useCallback((l) => {
    if (!['it', 'en'].includes(l)) return;
    setLang(l);
    try { localStorage.setItem('pa_lang', l); } catch { /* Language switching still works when storage is unavailable. */ }
  }, []);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let cur = translations[lang] || translations.en;
      for (const p of parts) {
        cur = cur?.[p];
        if (cur === undefined) {
          // fallback to english
          let en = translations.en;
          for (const p2 of parts) en = en?.[p2];
          return en ?? path;
        }
      }
      return cur;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider
      value={{
        lang,
        changeLang,
        t,
        tv: useCallback((v, context) => localizeTerm(v, lang, context), [lang]),
        loc: useCallback((v) => localize(v, lang), [lang]),
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};


